<template>
  <label class="container" :class="{ large, medium }">
    {{ label }}
    <input
      v-model="checked"
      type="checkbox"
      :disabled="disabled"
      @change="$emit('check', checked)"
    />
    <span class="checkmark" :class="{ square, large, medium }"></span>
  </label>
</template>
<script setup>
import { ref } from 'vue'
const emit = defineEmits(['check'])
const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  medium: Boolean,
  large: Boolean,
  square: Boolean,
  active: Boolean,
  disabled: Boolean
})

const checked = ref(props.active)
</script>
<style lang="scss" scoped>
/* Customize the label (the container) */
.container {
  display: block;
  height: 12px;
  width: 12px;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &.medium {
    height: 15px;
    width: 15px;
  }
  &.large {
    height: 20px;
    width: 20px;
  }

  /* Hide the browser's default radio button */
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border: 2px solid $blue-80;
    background-color: $white;
    border-radius: 50%;
    box-sizing: content-box;

    &.square {
      border-radius: 0%;
    }

    &.medium {
      &:after {
        width: 8px;
        height: 8px;
      }
    }

    &.large {
      &:after {
        width: 10.5px;
        height: 10.5px;
      }
    }
  }

  /* On mouse-over, add a grey background color */
  &:hover input ~ .checkmark {
    background-color: $blue-80;
  }

  &:hover input ~ .checkmark:after {
    display: block;
  }

  /* When the radio button is checked, add a blue background */
  input:checked ~ .checkmark {
    background-color: $blue-80;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .checkmark:after {
    top: 25%;
    left: 24%;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: white;
  }
}
</style>
